import axios from 'axios';

// Add a request interceptor
axios.interceptors.request.use(async function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    return Promise.reject(error);
});

export default axios;